export const GET_PRODUCTS = "GET_PRODUCTS";
export const PRODUCTS_LOADING = "PRODUCTS_LOADING";
export const PRODUCTS_LOADED = "PRODUCTS_LOADED";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const RETRIEVE_CART = "RETRIEVE_CART";
export const SET_CART = "SET_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SET_CHECKOUT_TOKEN = "SET_CHECKOUT_TOKEN";
export const GET_FIRSTNAME = "GET_FIRSTNAME";
export const GET_LASTNAME = "GET_LASTNAME";
export const GET_EMAIL = "GET_EMAIL";
export const GET_CITY = "GET_CITY";
export const GET_POSTCODE = "GET_POSTCODE";
export const GET_ADDRESS = "GET_ADDRESS";
export const GET_REGION = "GET_REGION";
export const GET_COUNTRY = "GET_COUNTRY";
export const SORT_BY_PRICE = "SORT_BY_PRICE";
export const TOGGLE_PRICE_HANDLER = "TOGGLE_PRICE_HANDLER";
export const TOGGLE_SOLD_OUT_HANDLER = "TOGGLE_SOLD_OUT_HANDLER";
export const HIDE_SOLD_OUT = "HIDE_SOLD_OUT";
